import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../../components/Seo';
import { ROUTES } from '../../enum/routes';

export default function TermsPage() {
	return (
		<>
			<Seo
				title='Terms & Conditions | Epic Home Pros'
				description='Terms and conditions for using epichomepros.com and submitting a quote request to Epic Home Pros.'
				path={ROUTES.TERMS}
			/>
			<section className='bg-forest-tint py-16 sm:py-20'>
				<div className='container-page'>
					<div className='mx-auto max-w-3xl'>
						<div className='label-eyebrow'>Legal</div>
						<h1 className='h-display mt-3'>Terms &amp; Conditions</h1>
						<p className='mt-4 text-sm text-ink/60'>
							Last updated: September 3, 2026
						</p>
						<p className='mt-6 text-lg leading-relaxed text-ink/75'>
							These terms govern your use of epichomepros.com and any quote
							request you submit to Epic Home Pros.
						</p>
					</div>
				</div>
			</section>
			<section className='py-14 sm:py-20'>
				<div className='container-page'>
					<div className='mx-auto max-w-3xl space-y-10'>
						<section>
							<h2 className='font-serif text-2xl leading-snug text-ink'>
								The service
							</h2>
							<div className='mt-4 space-y-4 text-base leading-relaxed text-ink/80'>
								<p>
									Epic Home Pros is a lead-matching service. We connect
									homeowners who request a free remodel quote with licensed
									local remodeling partners. We are not a general contractor,
									and we do not perform construction, remodeling, or
									installation work.
								</p>
								<p>
									Any contract for construction work is between you and the
									partner you choose to hire. Epic Home Pros is not a party to
									that contract and does not guarantee a partner’s pricing,
									schedule, or workmanship.
								</p>
							</div>
						</section>
						<section>
							<h2 className='font-serif text-2xl leading-snug text-ink'>
								Quotes and estimates
							</h2>
							<div className='mt-4 space-y-4 text-base leading-relaxed text-ink/80'>
								<p>
									Submitting a form does not create a construction contract.
									Estimates provided by partners are their own. A quote is not
									an obligation to hire anyone. Cost ranges published on this
									site are market illustrations, not bids.
								</p>
							</div>
						</section>
						<section>
							<h2 className='font-serif text-2xl leading-snug text-ink'>
								Accuracy
							</h2>
							<div className='mt-4 space-y-4 text-base leading-relaxed text-ink/80'>
								<p>
									You agree that the contact and project information you submit
									is accurate. We may share that information with a remodeling
									partner so they can contact you about an on-site estimate.
								</p>
							</div>
						</section>
						<section>
							<h2 className='font-serif text-2xl leading-snug text-ink'>SMS</h2>
							<div className='mt-4 space-y-4 text-base leading-relaxed text-ink/80'>
								<p>
									If you opt in to texts, message and data rates may apply.
									Frequency varies. Reply STOP to opt out and HELP for help.
									Consent is not required to request a quote. See our{' '}
									<Link
										className='text-forest underline hover:text-forest-hover'
										to='/privacy'
									>
										Privacy Policy
									</Link>
									.
								</p>
							</div>
						</section>
						<section>
							<h2 className='font-serif text-2xl leading-snug text-ink'>
								Website use
							</h2>
							<div className='mt-4 space-y-4 text-base leading-relaxed text-ink/80'>
								<p>
									Do not misuse the site, scrape it, or submit false leads.
									Content on this site is for information only. Photography is
									illustrative and does not represent a specific completed Epic
									Home Pros job.
								</p>
							</div>
						</section>
						<section>
							<h2 className='font-serif text-2xl leading-snug text-ink'>
								Limitation of liability
							</h2>
							<div className='mt-4 space-y-4 text-base leading-relaxed text-ink/80'>
								<p>
									To the fullest extent allowed by Texas law, Epic Home Pros is
									not liable for work performed by independent remodeling
									partners, including defects, delays, or injuries on a job
									site. Our role is introductions, not construction.
								</p>
							</div>
						</section>
						<section>
							<h2 className='font-serif text-2xl leading-snug text-ink'>
								Contact
							</h2>
							<div className='mt-4 space-y-4 text-base leading-relaxed text-ink/80'>
								<p>
									<strong>Epic Home Pros</strong>
									<br />
									hello@epichomepros.com
									<br />
									<a
										href='tel:+18448003742'
										className='text-forest underline hover:text-forest-hover'
									>
										(844) 800-EPIC
									</a>
								</p>
							</div>
						</section>
					</div>
				</div>
			</section>
		</>
	);
}
